import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate } from '@/utils/formUtils.js'
export default {
  inbound (ctx, data) {
    return fetch.inbound(data).then(res => {
      return res
    })
  },
  getBoxType (ctx) {
    return fetch.getBoxType().then(res => {
      return res
    })
  },
  findAgentIdBySampleId (ctx, data) {
    return fetch.findAgentIdBySampleId(data).then(res => {
      return res
    })
  },
  getBoxInventories (ctx, data) {
    return fetch.getBoxInventories(data).then(res => {
      res.data.forEach(e => {
        e.storageDateCopy = formatDate(e.storageDate)
        e.productionDateCopy = formatDate(e.productionDate)
        e.expirationDateCopy = formatDate(e.expirationDate)
        e.storeStatus = e.inStore ? '在库' : '已出库'
        e.sendSampleStatus = e.sendSample ? '已回寄' : '未回寄'
        e.productNameCopy = e.productList ? e.productList.map(item => item.name).toString() : (e.product ? e.product.name : '')
      })
      return getTotalNumber(res)
    })
  },
  searchBoxInventories (ctx, data) {
    return fetch.searchBoxInventories(data).then(res => {
      res.data.forEach(e => {
        e.storageDateCopy = formatDate(e.storageDate)
        e.productionDateCopy = formatDate(e.productionDate)
        e.expirationDateCopy = formatDate(e.expirationDate)
        e.storeStatus = e.inStore ? '在库' : '已出库'
        e.sendSampleStatus = e.sendSample ? '已回寄' : '未回寄'
        e.productNameCopy = e.productList ? e.productList.map(item => item.name).toString() : (e.product ? e.product.name : '')
      })
      return getTotalNumber(res)
    })
  },
  findDetailBySampleId (ctx, data) {
    return fetch.findDetailBySampleId(data).then(res => {
      return res
    })
  },
  outbound (ctx, data) {
    return fetch.outbound(data).then(res => {
      return res
    })
  },
  getProductByClientId (ctx, data) {
    return fetch.getProductByClientId(data).then(res => {
      return res
    })
  },
  getBoxDetail (ctx, id) {
    return fetch.getBoxDetail(id).then(res => {
      return res.data
    })
  },
  updateBox (ctx, data) {
    return fetch.updateBox(data).then(res => {
      return res.data
    })
  }
}
